'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';

interface ContactSupportProps {
  id: string;
}

const ContactSupport = ({ id }: ContactSupportProps) => (
  <AgxSpacer
    direction="horizontal"
    gap="spacing-md"
    contentAlignment="center"
    contentJustification="center"
    wrap
  >
    <AgxTypography
      id={`${id}-support-label`}
      type="body_ui"
      size="medium"
      color="var(--text-tertiary, #94a3b8)"
    >
      Need help?
    </AgxTypography>
    <a
      id={`${id}-contact-support`}
      className="onboarding-page__support-link"
      href="mailto:support@autopilot.com.au"
    >
      <AgxTypography id={`${id}-contact-support-label`} type="hyperlink" size="medium">
        Contact Autopilot Support
      </AgxTypography>
    </a>
  </AgxSpacer>
);

export default ContactSupport;
